export var GET_CONFIG = '[CONFIG] GET';
export var GET_CONFIG_SUCCESS = '[CONFIG] GET_SUCCESS';
export var GET_CONFIG_FAIL = '[CONFIG] GET_FAIL';
var GetConfig = /** @class */ (function () {
    function GetConfig() {
        this.type = GET_CONFIG;
    }
    return GetConfig;
}());
export { GetConfig };
var GetConfigSuccess = /** @class */ (function () {
    function GetConfigSuccess(payload) {
        this.payload = payload;
        this.type = GET_CONFIG_SUCCESS;
    }
    return GetConfigSuccess;
}());
export { GetConfigSuccess };
var GetConfigFail = /** @class */ (function () {
    function GetConfigFail(payload) {
        this.payload = payload;
        this.type = GET_CONFIG_FAIL;
    }
    return GetConfigFail;
}());
export { GetConfigFail };



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/store/actions/config.action.ts.pre-build-optimizer.js